import React from 'react';
import { UsersIcon, MapPinIcon, SparklesIcon, UtensilsIcon } from 'lucide-react';
const features = [{
  icon: UsersIcon,
  title: 'Capacity',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor'
}, {
  icon: MapPinIcon,
  title: 'Location',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor'
}, {
  icon: SparklesIcon,
  title: 'Amenities',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor'
}, {
  icon: UtensilsIcon,
  title: 'Catering',
  description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit sed do eiusmod tempor'
}];
export function Features() {
  return <section id="venue" className="py-20 sm:py-24 lg:py-32 bg-stone-50" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-black mb-4" data-id="element-35">
            Why Choose Gardendale Venue
          </h2>
          <div className="w-16 h-px bg-gray-400 mx-auto" data-id="element-36"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12" data-id="element-37">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="text-center" data-id="element-38">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-6" data-id="element-39">
                  <Icon className="w-8 h-8 text-gray-700" data-id="element-40" />
                </div>
                <h3 className="text-xl font-serif font-bold text-black mb-3 tracking-wide" data-id="element-41">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-42">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}